export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t-2 border-[#29abe2]/30 bg-[#fdfbf6] py-12">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <div className="mb-6 flex items-center justify-center gap-2">
          <span className="h-1.5 w-8 rounded-full bg-[#29abe2]" />
          <span className="h-1.5 w-4 rounded-full bg-[#f5b301]" />
          <span className="h-1.5 w-2 rounded-full bg-[#c1272d]" />
        </div>
        <img
          src="/kohinoor-logo.webp"
          alt="Hotel Kohinoor"
          className="mx-auto h-20 w-auto object-contain opacity-95 mb-6"
          draggable="false"
        />
        <p className="text-sm text-[#52525b]" data-testid="footer-copyright">
          © Hotel Kohinoor. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
